
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/my-elections",
      function () {
        return require("private-next-pages/elections/my-elections.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/my-elections"])
      });
    }
  